import React from 'react';
import PropTypes from 'prop-types';

import {
  QuestionLabel,
  Container,
} from '../styles';

const TextQuestionType = (props) => {
  const {
    label,
    index,
  } = props;

  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Text)`}</QuestionLabel>
    </Container>
  );
};

TextQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default TextQuestionType;
